/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum TicketDepartment {
  MOTOR_CARRIER_DIVISION = 'motor_carrier_division',
  ENFORCEMENT = 'enforcement',
}
